import * as React from 'react';
import { SearchTypeEnum } from '../../../types/SearchTypeEnum';
import GridViewItem from './GridViewItem';
import SearchBar from '../../SearchBar';
import './GridView.scss';

interface GridViewProps {
    data?: any;
    columns: any;
    canEdit: boolean;
    onEdit?: (record: any) => void;
    onDelete?: (record: any) => void;
    onCreate?: () => void;
    onSearch?: (text: string) => void;
}

export const GridView = ({
    data,
    onDelete,
    canEdit,
    onEdit,
    columns,
    onCreate,
    onSearch,
}: GridViewProps): React.ReactElement => {
    return (
        <div className="GridView-Container">
            <div className="GridView-Top-Container">
                <div className="GridView-SearchBar">
                    <SearchBar type={SearchTypeEnum.Customer} onChange={onSearch}></SearchBar>
                </div>
                <div className="GridView-RightOptions">
                    {canEdit && onCreate && (
                        <div className="GridView-Create-New Row" onClick={onCreate}>
                            <i className="material-icons CustomerParents-Icon">add_circle</i>
                            <span className="CustomerParents-Link">Create New Proppant</span>
                        </div>
                        // <CustomButton
                        //     title="Create New"
                        //     isBordered
                        //     onClick={onCreate}
                        //     additionalStyle={'Grid-View-Btn'}
                        // />
                    )}
                </div>
                <div className="CustomerParents-Errors"></div>
            </div>
            <div className="GridView-Bottom-Container">
                {(columns || []).map((column, key) => {
                    return (
                        <div key={key} className="GridView-Header-Title">
                            {column.title}
                        </div>
                    );
                })}
            </div>
            <div className="GridView-List">
                {(data || []).map((record, index) => (
                    <GridViewItem
                        key={`GridViewRow${index}`}
                        index={index}
                        canEdit={canEdit}
                        record={record}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        columns={columns}
                        //onEditClick={onEditClick}
                    ></GridViewItem>
                ))}
            </div>
        </div>
    );
};

export default GridView;
